import type { SensorTypeDtoEnumType } from '@mark43/cad-api';

/**
 * The only sensor type the backend supports today.
 *
 * Now a generated enum member rather than the free string it used to be: `SensorTypeDto` is a
 * `Mark43IntEnum` on the wire, closed by construction because a value is only added when CAD ships
 * an integration. (An *alert*'s type stays a string for the opposite reason — those are created by
 * vendor-side rule configuration, and collapsing an unrecognised one would destroy the label the
 * client has to display.)
 */
export const SENSOR_TYPE_VERKADA_CAMERA: SensorTypeDtoEnumType = 'VERKADA_CAMERA';

/** Realtime stream carrying inbound sensor alerts. Also a key of `StreamMap`. */
export const SENSOR_ALERT_STREAM_NAMES = ['sensorAlert'] as const;

/**
 * Seconds of already-played video each live feed keeps buffered. hls.js keeps all of it by default
 * (`backBufferLength: Infinity`), so a feed's memory grows for as long as it plays, and the grid
 * runs nine. Seeking further back still works: hls.js downloads those segments again.
 */
export const SENSOR_HLS_BACK_BUFFER_SECONDS = 60;
